
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <>
      <section className="about-us-page">
        <Container>


          <div className="Heading_section ">
            <h2>Our Promise</h2>
            <p>
              We aim to provide excellent service and creative solutions that leave our clients completely satisfied.
            </p>
          </div>

          {/* vission secion */}
          <div className="Mission_mission_section">
            <Row >
              <Col md={6} sm={6} xs={12} >
                <div className="about-image">
                  <img
                    src="/assets/images/about_us/vission/img1.png"
                    alt="Our Vision"
                    className="vission_mission_img"
                  />
                </div>
              </Col>
              <Col md={6} sm={12} xs={12}  >
                <div className="about-text">
                  <h3>Our Vision</h3>
                  <p>
                    Our vision is to be the top partner for treasury solutions in the financial services industry. We provide comprehensive support from the initial setup all the way through the entire lifecycle. Our approach is to positively guide the change management process for both banks and their clients, ensuring a smooth and successful transition.
                  </p>
                  <p>
                    We excel at delivering customized solutions for everything from check processing and cash vault supplies to remote deposit capture and smart safe technology, all backed by dedicated call center support.
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          {/* mission secion */}

          <div className="Mission_mission_section ">
            <Row>
              <Col md={6} sm={6} xs={12} className=" order-md-2 order-sm-1">
                <div className="about-image">
                  <img
                    src="/assets/images/about_us/vission/img2.png"
                    alt="Our Values"
                    className="vission_mission_img"
                  />
                </div>
              </Col>
              <Col md={6} sm={12} xs={12} className="order-md-1  order-sm-2">
                <div className="about-text">
                  <h3>Our Values</h3>

                  <p><b>Quality Assurance:</b> <br /> Quality is the foundation of our business. We meticulously test and inspect every product to ensure it meets the highest standards for accuracy, durability, and performance.</p>

                  <p><b>Customer-Centric Approach:</b> <br /> At Croma Venture, we put your needs first. We provide customized solutions that fit your specific requirements, and our support team is committed to offering exceptional service and guidance every step of the way.</p>

                  <p><b>Innovation and Adaptability:</b> <br /> The financial world is always changing. We are dedicated to staying ahead of industry trends and technology, ensuring that our solutions evolve to meet your changing needs.</p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default AboutUs;